<template>
    <div class="about_fqr">
        <content-card v-for="( item, index ) in items" :key="index" :items="item"></content-card>
    </div>
</template>
<script>
import ContentCard from "@/components/contentComp/ContentCard.vue";

export default {
    name: "fqr",
    components: {
        ContentCard,
    },
    data() {
        return {
            items:[
                {
                    title:{
                        icon_title: "天下商邦发起人",
                    },
                    type: "IDCards",
                    content:[
                        {
                            img: require('@/assets/gywm/faqiren/jxb.jpg'),
                            name: "蒋宪彬",
                            titles:[
                                "归农创始人，",
                                "天下商邦董事局主席，",
                                "上海泰和商会会长，",
                                "2020年度中国农牧行业功勋企业家（AWA联盟），",
                                "南昌大学新闻与传播学院“蒋宪彬励志奖学金”创立者。",
                            ],
                            txt: "中国农产品社交电商先锋，独创 “三社方法论”（ 社群+社团+社区），在农业电商领域，带领团队从13个种子客户发展到现在900万+会员。",
                        },
                        {
                            img: require('@/assets/gywm/faqiren/dlp.jpg'),
                            name: "段力平",
                            titles:[
                                "博士，",
                                "著名企业家、投资家，段永平的亲哥。",
                            ],
                        },
                        {
                            img: require('@/assets/gywm/faqiren/lxq.jpg'),
                            name: "鲁晓强",
                            titles:[
                                "天然彩棉内衣品牌“朵彩”创始人，",
                                "中国第三次内衣浪潮引领者。",
                            ],
                        },
                        {
                            img: require('@/assets/gywm/faqiren/zwh.jpg'),
                            name: "张卫华",
                            titles:[
                                "上海触觉艺术馆馆长，",
                                "上海古瀛艺术设计工程有限公司，",
                                "董事长兼艺术总监。",
                            ],
                        },
                        {
                            img: require('@/assets/gywm/faqiren/hm.jpg'),
                            name: "黄梦",
                            titles:[
                                "移动互联网第一股“点点客”创始人/董事长。",
                            ],
                        },
                        {
                            img: require('@/assets/gywm/faqiren/zht.jpg'),
                            name: "赵海涛",
                            titles:[
                                "人人电商商学院前院长，",
                                "点点客集团前副总裁。",
                            ],
                        },
                        {
                            img: require('@/assets/gywm/faqiren/zxs.jpg'),
                            name: "张校硕",
                            txt: "著名广告导演/创意人，曾任多家国际FA广告创意总监，中国第一个戛纳金狮奖得主，并两次获得该奖项，曾创作华为“非极致不为”、奔驰“不是为了走得更远，而是为了离得更近”/“只有赤裸的心，才配穿上泥沙”、腾讯年度大片等经典现任网易云音乐“放刺”品牌全球创意总监、总导演。",
                        },
                        {
                            img: require('@/assets/gywm/faqiren/clh.jpg'),
                            name: "蔡林宏",
                            titles:[
                                "著名广告人，",
                                "曾任华为消费品市场全球创意总监。",
                            ],
                        },
                    ],
                },
            ],
        };
    },
};
</script>
<style lang="scss" scoped>
.about_fqr{
    width:1500px;
}
</style>